import axios from "axios";

// Crear una instancia de Axios
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Define la URL base de tu API
  // baseURL: "http://localhost:3001", // Define la URL base de tu API
});

// Agregar un interceptor para incluir el token en cada solicitud
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = token; // Agrega el token al header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Agregar un interceptor para cerrar sesión ante un token inválido o expirado
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";

    if ((status === 401 || status === 403) && !url.includes("/users/login")) {
      localStorage.removeItem("token");
      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
